import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useFlow } from "../../context/FlowContext";
import { useI18N } from '../../context/I18NContext';
import useWidgetStore from '../../store/useWidgetStore';
import Variation from './Variation';
import Amount from './Amount';
import { moneyFormat } from '../../helpers/general';
import { isDesktop } from '../../../../helpers/browser';
import useDataStore from '../../store/useDataStore';
export default function Purchase(props) {
    var _a;
    const flow = useFlow();
    const { t } = useI18N();
    const { cart } = useWidgetStore();
    const { getProduct, products } = useDataStore();
    const [amount, setAmount] = useState(1);
    const [maxAmount, setMaxAmount] = useState(99);
    const [price, setPrice] = useState(1);
    const [productId, setProductId] = useState();
    const [inCart, setInCart] = useState();
    useEffect(() => {
        setInCart(false);
        setAmount(1);
        setProductId(props.productId);
        setPrice(props.product.price);
        setMaxAmount(props.product.trackStock ? props.product.stock : 99);
    }, [props.productId, cart.lines]);
    useEffect(() => {
        if (productId) {
            let product = getProduct(productId);
            if (product && product.trackStock) {
                setMaxAmount(product.stock);
            }
            else {
                setMaxAmount(99);
            }
        }
    }, [products, productId]);
    useEffect(() => {
        // if we get maxAmount set to null or undefined, set it to 99, but if it's 0, leave as is ( appearantly !maxAmount is true for 0, I did not expect this in TypeScript where maxAmount is defined as a number)
        if (!maxAmount && maxAmount !== 0) {
            setMaxAmount(99);
        }
    }, [maxAmount]);
    useEffect(() => {
        setAmount(1);
        if (productId) {
            let product = getProduct(productId);
            if (product) {
                setPrice(product.isVariation && product.variation ? product.variation.price : product.price);
                setMaxAmount(product.trackStock ? product.stock : 99);
            }
        }
    }, [productId]);
    const handleClick = () => {
        if (props.selectCallback) {
            props.selectCallback(productId, amount);
        }
        else {
            // @ts-ignore
            flow === null || flow === void 0 ? void 0 : flow.onNext();
        }
    };
    return (_jsxs(_Fragment, { children: [props.product.variances && ((_a = props.product.variances) === null || _a === void 0 ? void 0 : _a.length) > 0 && (_jsx(Variation, { object: props.product, variance: props.product.variances[0], setter: setProductId })), _jsx(Typography, { variant: "h6", sx: { color: 'text.secondary', marginY: 1, fontSize: '1.5rem', fontWeight: 'bolder' }, children: moneyFormat(price) }), maxAmount > 0 && (_jsx(_Fragment, { children: _jsxs(Grid, { container: true, spacing: 0, sx: { marginX: 0, width: "100%" }, children: [_jsx(Grid, { item: true, xs: isDesktop ? 6 : 12, sx: Object.assign({}, (!isDesktop && {
                                marginBottom: 1
                            })), children: _jsx(Amount, { value: amount, setter: setAmount, object: props.product, max: maxAmount }) }), _jsx(Grid, { item: true, xs: isDesktop ? 6 : 12, children: _jsx(Button, { onClick: handleClick, fullWidth: true, variant: "contained", sx: { height: '46px' }, children: t(props.required ? 'Selecteren' : (inCart ? 'Wijzig' : 'Kopen')) }) })] }) }))] }));
}
